var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Button from "../button/button";
import Icon from '@assets/tsx/icon/pickerIcon';
import { Link } from '@ambiguous/link';
import Image from "@assets/tsx/image";
export default function Card({ title, url: cardUrl, url__props, content, underscored, image, image_stretch, buttons, logos, ulist, bg_color, image_square, switch_layout, image_stretch_vertical }) {
    const bg_styles = bg_color ? { style: { backgroundColor: bg_color } } : null;
    const svg_styles = bg_color ? { style: { color: bg_color } } : null;
    const { url, alt, srcset } = image || {};
    return (React.createElement("div", { className: `ltg-card-cropped${image_stretch == 'yes' ? ' ltg-card--img-stretch' : ''}${!url ? ' ltg-card--no-img' : ''}${switch_layout === 'yes' ? ' ltg-card--reverse' : ''}${image_stretch_vertical ? ' ltg-card--img-stretch-vertical' : ''}` },
        React.createElement("div", Object.assign({ className: "ltg-card" }, bg_styles),
            React.createElement("div", { className: "ltg-card-text-wrap" },
                React.createElement("div", { className: 'ltg-card-text-content' },
                    React.createElement("h2", { className: "ltg-card-title" }, cardUrl ? (React.createElement(Link, { href: cardUrl, target: (url__props === null || url__props === void 0 ? void 0 : url__props.blank) ? '_blank' : null, className: !!underscored ? 'ltg-card-underscored' : '' }, title)) : (React.createElement("span", { className: !!underscored ? 'ltg-card-underscored' : '' }, title))),
                    content && React.createElement("div", { className: "ltg-card-description", dangerouslySetInnerHTML: { __html: content } }),
                    !!(ulist === null || ulist === void 0 ? void 0 : ulist.length) && React.createElement(UList, { items: ulist }),
                    !!(logos === null || logos === void 0 ? void 0 : logos.length) && React.createElement(LogoWrap, { logos: logos })),
                (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && React.createElement(ButtonWrap, { buttons: buttons })),
            url && (React.createElement("div", { className: "ltg-card-img-wrap" },
                image_square !== 'yes' && (React.createElement("svg", Object.assign({ className: "ltg-card-mask", version: "1.1", viewBox: "0 0 673.67 481.3", xmlns: "http://www.w3.org/2000/svg" }, svg_styles),
                    React.createElement("path", { d: "m0 0v481.3h673.65l-598.48-0.45703c-3.0929 2e-3 -6.1818-0.22435-9.2415-0.67578-23.367-0.48693-44.699-13.373-55.973-33.809-11.274-20.436-10.777-45.32 1.3032-65.291 1.0018-2.519 1.7121-3.9102 1.7121-3.9102l171.42-262.21c55.677-84.721 104.57-113.21 189.52-113.11l6e-3 0.00586 299.73-1.8359v-0.0078131z", fill: 'currentColor' }))),
                React.createElement(Image, { className: "ltg-card-img", src: url, alt: alt || title, srcSet: srcset }))))));
}
function UList({ items }) {
    return (React.createElement("ul", { className: "ltg-card-ul" }, items.map(({ _id, text, url, bold, icon, url_blank }) => {
        return (React.createElement("li", { key: _id },
            React.createElement("div", { className: "ltg-card-ul-item" },
                (icon === null || icon === void 0 ? void 0 : icon.iconClassName) && (React.createElement("div", { className: "ltg-card-ul-icon" },
                    React.createElement(Icon, Object.assign({}, icon)))),
                React.createElement("div", { className: "ltg-card-ul-text" },
                    React.createElement(Text, { url: url, text: text, bold: bold, url_blank: url_blank })))));
    })));
}
function Text({ text, url, bold, url_blank }) {
    if (!bold && !url) {
        return (React.createElement(React.Fragment, null, text));
    }
    if (!bold && url) {
        return (React.createElement(Link, { href: url, target: url_blank === 'yes' ? '_blank' : null, rel: "nofollow" }, text));
    }
    if (bold && !url) {
        return (React.createElement("b", null, text));
    }
    return (React.createElement(Link, { href: url, rel: "nofollow", target: url_blank === 'yes' ? '_blank' : null },
        React.createElement("b", null, text)));
}
function ButtonWrap({ buttons }) {
    return (React.createElement("div", { className: "ltg-card-button-wrap" }, buttons && buttons.map((_a) => {
        var { _id } = _a, rest = __rest(_a, ["_id"]);
        return (React.createElement(Button, Object.assign({ key: _id }, rest)));
    })));
}
function LogoWrap({ logos }) {
    return (React.createElement("div", { className: "ltg-card-logo-wrap" }, logos === null || logos === void 0 ? void 0 : logos.map(({ url, _id, image, title, target, image_template, image_width }) => {
        const { size, unit } = image_width || {};
        let custom_size = (image_template === 'custom' && !!size) ? { style: { width: `${size}${unit}` } } : {};
        return (React.createElement(Link, { href: url, key: _id, className: "ltg-card-logo", title: title, target: target || null, rel: target ? 'noreferrer noopener' : null },
            React.createElement("img", Object.assign({ src: image.url, alt: image.alt || title, className: `ltg-card-logo-img${image_template !== 'auto' ? ` ltg-card-logo--tpl-${image_template}` : ''}` }, custom_size))));
    })));
}
